"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getSamlToken = void 0;
var _SecureClient = require("../SecureClient");
// eslint-disable-next-line import/prefer-default-export
const getSamlToken = providerId => {
  const secureClient = new _SecureClient.SecureClient();
  return secureClient.get(`/security/saml/authn-response/${providerId}/get`);
};
exports.getSamlToken = getSamlToken;
//# sourceMappingURL=Saml.js.map